import * as React from "react"

const RweMiddle = (props) => (
    <svg
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <path
            d="M490 452c20.435 0 37-16.565 37-37s-16.565-37-37-37-37 16.565-37 37 16.565 37 37 37ZM453 510c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24ZM367 505c14.912 0 27-12.088 27-27s-12.088-27-27-27-27 12.088-27 27 12.088 27 27 27Z"
            fill="#B5179E"
        />
        <path
            d="M336 470c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20ZM462 415c16.016 0 29-12.984 29-29s-12.984-29-29-29-29 12.984-29 29 12.984 29 29 29ZM366 366c14.359 0 26-11.641 26-26s-11.641-26-26-26-26 11.641-26 26 11.641 26 26 26ZM454 354c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z"
            fill="#B5179E"
        />
        <path
            d="M491 339c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Z"
            fill="#F72585"
        />
    </svg>
)

export default RweMiddle
